module.exports = __webpack_public_path__ + "img/gz_qrcode.612c69fd.jpg";